import { render, staticRenderFns } from "./StandappLinkBusinessComponent.vue?vue&type=template&id=1c73846a&scoped=true&"
import script from "./StandappLinkBusinessComponent.vue?vue&type=script&lang=js&"
export * from "./StandappLinkBusinessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c73846a",
  null
  
)

export default component.exports